import axios from "axios";

const API_URL = process.env.REACT_APP_SOCIALPIKA_API_URL;

const readToken = () => {
  try {
    const stored = JSON.parse(localStorage.getItem("authTokens"));
    return stored && stored.token ? stored.token : "";
  } catch (error) {
    return "";
  }
};

export const isApiRequest = (url) =>
  Boolean(API_URL) && typeof url === "string" && url.startsWith(API_URL);

// Adds the session token to every call to our API, unless a call sets its own.
export const attachAuthorization = (config) => {
  if (isApiRequest(config.url)) {
    const token = readToken();
    config.headers = config.headers || {};
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = token;
    }
  }
  return config;
};

let installed = false;
export const installApiClient = () => {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use(attachAuthorization);
};

export default axios;
